import { Injectable } from '@angular/core';
import { Appointment } from '../models/appointment.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Document } from '../models/document';

@Injectable({
  providedIn: 'root',
})
export class DocumentationService {
  private apiUrl = environment.APP_BASE_URL + '/doctor-portal/booking-view/documents'; // replace with real API endpoint

  constructor(private http: HttpClient) {}

  public downloadPrescriptionLetter(prescriptionId: string | undefined): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/prescription-letter/${prescriptionId}`, {
      responseType: 'blob',
    });
  }

  public downloadSickNote(sickNoteId: string | undefined): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/sick-note/${sickNoteId}`, {
      responseType: 'blob',
    });
  }

  public getAppointmentDocuments(appointmentId: string | undefined): Observable<Document[]> {
    return this.http.get<Document[]>(`${this.apiUrl}/${appointmentId}`);
  }
}
